<template>
  <Modal
    classContent="congeners-modal"
    title="Detalhes da isenção de vistoria de 0 km"
    :active="active"
    @close="closeModal()"
  >
    <ValidationObserver ref="editForm" v-slot="{ invalid }">
      <div class="vx-row">
        <div class="vx-col w-full mt-4">
          <div>
            <label class="label-text " for="active-switch"
            >Isentar vistoria de 0 km que saiu da concessionária?
            </label>
            <vs-switch
              color="success"
              name="active-switch"
              v-model="form.active"
              style="width: 60px"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div v-if="form.active" class="vx-col w-full mt-4">
          <ValidationProvider
            name="Quantidade de dias"
            rules="required|integer|min_value:0"
            immediate
            v-slot="{ errors }"
          >
            <label class="label-text">
              Diferença máx. de dias entre saída da concessionária e transmissão para isentar vistoria
            </label>
            <vs-input
              v-model="form.days"
              type="number"
              placeholder="Informe a quantidade de dias"
              class="w-full"
              :danger="!!errors.length"
            />
            <span v-show="!!errors.length" class="text-danger"
            >{{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
        <div class="vx-col w-full mt-4">
          <ValidationProvider
            name="descrição do tooltip"
            rules="required"
            immediate
            v-slot="{ errors }"
          >
            <label class="label-text">
              Descrição do tooltip exibido na tela de transmissão de proposta
            </label>
            <vs-textarea
              v-model="form.tooltipText"
              type="text"
              class="w-full"
              placeholder="Informe a descrição do tooltip"
              :class="!!errors.length ? 'is-danger' : ''"
            />
            <span v-show="!!errors.length" class="text-danger"
            >{{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="save"
            type="gradient"
            color="primary"
            class="mt-5"
            :disabled="invalid"
          >
            Salvar
          </vs-button>
        </div>
      </div>
    </ValidationObserver>
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import {ValidationObserver, ValidationProvider} from 'vee-validate';

export default {
  name: 'DealershipExitDaysModal',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    registrations: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      form: {
        active: false,
        days: null,
        tooltipText: null,
      },
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Modal,
  },
  methods: {
    open() {
      if (this.registrations) {
        this.form = JSON.parse(this.registrations);
      }
    },
    closeModal() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', JSON.stringify(this.form));
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.open();
        }
      },
    }
  }
};
</script>
<style scoped>
.label-text {
  font-size: 12px;
  font-weight: 200;
  color: #333;
}

.is-danger {
  border-color: #ff3860 !important;
}
</style>
